import React, { useState } from "react";
import {
  DashboardOutlined,
  PieChartOutlined,
  SettingOutlined,
  MonitorOutlined,
  DownOutlined,
  UpOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";

const Sidebar = () => {
  // const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State for Yönetim Paneli Dropdown

  const menuItems = [
    { name: "Ana Sayfa", path: "/", icon: <DashboardOutlined /> },
    { name: "Monitoring", path: "/monitoring", icon: <MonitorOutlined /> },
    { name: "Raporlar", path: "/reports", icon: <PieChartOutlined /> },
    { name: "Çalışma Saatleri", path: "/workingHours", icon: <ClockCircleOutlined /> },
  ];

  const dropdownItems = [
    { name: "Makineler", path: "/management/machines" },
    { name: "Departmanlar", path: "/management/departments" },
    { name: "Kullanıcılar", path: "/management/users" },
    { name: "Firma Bilgileri", path: "/management/company" },
    { name: "Ayarlar", path: "/management/settings" },
    { name: "Lisanlar", path: "/management/licenses" },
  ];

  return (
    <div className="bg-black h-screen w-64 px-4 py-8 shadow-lg fixed top-0 left-0 z-50">
      {/* Logo */}
      <div className="text-2xl font-bold text-gray-100 mb-10">
        <div className="flex items-center">
            <NavLink to="/" className="logo">
              <img
                src="/softrein-beyaz.png"
                alt="Softrein Logo"
                style={{ height: "40px" }}
              />
            </NavLink>
          {/* <NavLink to="/">
            <span>Softrein</span>
          </NavLink> */}
        </div>
      </div>

      {/* Menü */}
      <div className="h-[calc(100vh-8rem)] overflow-y-auto scrollbar-thin scrollbar-track-black scrollbar-thumb-gray-700">
        <ul className="space-y-4">
          {menuItems.map((item) => (
            <li key={item.path}>
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center p-3 rounded-md text-gray-100 cursor-pointer ${
                    isActive
                      ? "bg-gray-800 text-blue-400"
                      : "hover:text-blue-500 hover:bg-gray-700"
                  }`
                }
              >
                <span className="mr-3">{item.icon}</span>
                {item.name}
              </NavLink>
            </li>
          ))}

          {/* Yönetim Paneli Dropdown */}
          <li>
            <div
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center justify-between p-3 rounded-md text-gray-100 cursor-pointer hover:bg-gray-700 hover:text-blue-500"
            >
              <div className="flex items-center">
                <SettingOutlined className="mr-3" />
                <span>Yönetim Paneli</span>
              </div>
              {isDropdownOpen ? (
                <UpOutlined className="text-xs" />
              ) : (
                <DownOutlined className="text-xs" />
              )}
            </div>
            {isDropdownOpen && (
              <ul className="pl-8 mt-2 space-y-2">
                {dropdownItems.map((item) => (
                  <li key={item.path}>
                    <NavLink
                      to={item.path}
                      className={({ isActive }) =>
                        `flex items-center p-2 rounded-md text-gray-100 ${
                          isActive
                            ? "bg-gray-800 text-blue-400"
                            : "hover:text-blue-500 hover:bg-gray-700"
                        }`
                      }
                    >
                      <span>{item.name}</span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            )}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
